import { forwardRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';
import { type HTMLMotionProps, motion } from 'framer-motion';

import css from './styles.module.scss';

const viewVariant = cva('', {
  variants: {
    variant: {
      default: css.cardFrontDefault,
    },
    size: {
      default: css.sizeBase,
      small: css.sizeSmall,
    },
  },
});

interface FrontCardViewProps
  extends HTMLMotionProps<'div'>,
    VariantProps<typeof viewVariant> {}

const FrontCardView = forwardRef<HTMLDivElement, FrontCardViewProps>(
  ({ variant = 'default', size = 'default', ...props }, ref) => {
    return (
      <motion.div
        ref={ref}
        {...props}
        className={cn(viewVariant({ variant, size }), props.className)}
      >
        <span className="font-extrabold text-white/40 leading-none">?</span>
      </motion.div>
    );
  },
);

export { FrontCardView };
